<template>
  <div
    class="regime_nav flex flex-nowrap p20 items-center bg-gray"
    :class="{
      'isSelected': isRegimeEnabled,
      'color--gray-darkest': isRegimeEnabled,
      'color--gray': !isRegimeEnabled
    }"
    @click="toggle()"
  >
    <SelectionMarker
      class="regime_nav__marker"
      color="gray-darkest"
      :selected="true"
      :type="'check'"
      v-if="isRegimeEnabled"
    ></SelectionMarker>

    <RegimeIcon :size="30" class="regime_nav__icon flex-none"></RegimeIcon>
    <div class="regime_nav__label flex-auto pr-10 pl-10 color--gray-darkest">
      Regime type <helptooltip
        :followMouse="false"
        class="regime_nav__label flex-none"
        :description="$Strings('regime_nav_tooltip')"
      ></helptooltip>
    </div>
  </div>
</template>

<script>
import RegimeIcon from './../../icons/RegimeIcon'
import SelectionMarker from './../shared/SelectionMarker'
import helptooltip from './../../misc/HelpTooltip'
// import _ from 'lodash'
// import {EventBus} from '@/event-bus.js'

export default {
  name: 'attribute-nav',
  components: { RegimeIcon, SelectionMarker, helptooltip },
  watch: {
    '$store.state.attributes.selected' () {
      // An attribute that has been selected
      // means that this filter is not
      if (this.$store.state.attributes.selected.length > 0) {
        this.$store.state.regime_enabled = 0
      } else {
        this.$store.state.regime_enabled = 1
      }
    }
  },
  computed: {
    isRegimeEnabled () {
      return this.$store.state.regime_enabled && !this.selectedAttribute
    },
    selectedAttribute () {
      return this.$store.getters['attributes/firstSelected']
    }
  },
  methods: {
    /**
     * This is not really a toggle as it is not allowed to untoggle this one
     * so we only turn it on if it has not already been selected
     *
     * @return  {void}
     */
    toggle () {
      if (!this.$store.state.regime_enabled) {
        this.$store.state.regime_enabled = true

        // We disable all other user selections
        this.$store.commit('resetSelectionColor')
        this.$store.commit('rsc/resetAllSelected')
        this.$store.commit('attributes/resetAllSelected')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .regime_nav {
    cursor: pointer;
    font-weight: 600;
    border-bottom: 1px solid $gray-lighter;
    position: relative;

    &__marker {
      position: absolute;
      left: 5px;
      top: 30px;
    }

    &.isSelected,
    &:hover {
      background: lighten($gray-lighter, 5%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/Regime.vue